<template>
  <div class="wrapper">
    <blurred-margin-poster
      src="https://m.media-amazon.com/images/M/MV5BN2Q1NWExNzEtM2M1Ny00ZDJhLWIwN2MtZGI5ZGI4MzBlYTQyXkEyXkFqcGdeQXVyOTYyMTY2NzQ@._V1_FMjpg_UX1000_.jpg"
    ></blurred-margin-poster>
  </div>
</template>

<script>
import BlurredMarginPoster from "../../components/poster-blurred-margins.vue";

export default {
  name: "dev-playground",

  components: { BlurredMarginPoster },
};
</script>

<style>
.wrapper {
  height: 300px;
  max-width: 500px;
}
</style>
